export default __webpack_public_path__ + "static/media/check.82e3f51e.svg";